import React from "react";
import "../Style/Testimonials.css";
import t1 from "../Assets/Testimonials/t1.png";
import t2 from "../Assets/Testimonials/t2.png";
import t3 from "../Assets/Testimonials/t3.png";
import t4 from "../Assets/Testimonials/t4.png";
import t5 from "../Assets/Testimonials/t5.png";
import t6 from "../Assets/Testimonials/t6.png";
import t7 from "../Assets/Testimonials/t7.png";
import t8 from "../Assets/Testimonials/t8.png";
import t9 from "../Assets/Testimonials/t9.png";
import {useAppointment} from "./AppointmentContext.js"
import BookAppointment from "./BookAppointment.js"
import { useAuth } from "./UserContext.js";
const Testimonials = () => {
  const { appointmentData,handleAppointment } = useAppointment();
  const testimonialData = [
    {
      imageUrl: t2,
      name: "Sarah M.",
      work: `"A Life-Changing Experience!"`,
      desc: `"I had been suffering from chronic migraines for years, and no conventional treatment seemed to work. After just a few sessions with Dr. R.K. VISHWAKARMA, I started noticing a significant reduction in the frequency and intensity of my migraines. I am now living a more comfortable, pain-free life, and I can’t thank Homeopathy Healthcare and Research Center enough for the transformative care!"`,
    },
    {
      imageUrl: t3,
      name: "Tom W.",
      work: `"A Natural Approach That Truly Works"`,
      desc: `"I had always been skeptical about homeopathy, but after trying multiple traditional treatments for my anxiety and stress without results, I decided to give it a shot. The remedies prescribed by Dr. R.K. VISHWAKARMA helped me feel more balanced, calm, and at peace with myself. I feel like myself again, and I’m so grateful for the natural healing process."`,
    },
    {
      imageUrl: t3,
      name: "Emily R.",
      work: `"Improved My Skin Health Like Never Before"`,
      desc: `"I struggled with eczema for many years, and it was affecting my confidence and daily life. I tried several treatments, but nothing seemed to work. After starting homeopathy treatment with Homeopathy Healthcare and Research Center, I noticed visible improvement in my skin within weeks. I am now eczema-free, and I can't express how much this has improved my quality of life."`,
    },
    {
      imageUrl: t4,
      name: "Emily R.",
      work: `"Improved My Skin Health Like Never Before"`,
      desc: `"I struggled with eczema for many years, and it was affecting my confidence and daily life. I tried several treatments, but nothing seemed to work. After starting homeopathy treatment with Homeopathy Healthcare and Research Center, I noticed visible improvement in my skin within weeks. I am now eczema-free, and I can't express how much this has improved my quality of life."`,
    },
    {
      imageUrl: t5,
      name: "Emily R.",
      work: `"Improved My Skin Health Like Never Before"`,
      desc: `"I struggled with eczema for many years, and it was affecting my confidence and daily life. I tried several treatments, but nothing seemed to work. After starting homeopathy treatment with Homeopathy Healthcare and Research Center, I noticed visible improvement in my skin within weeks. I am now eczema-free, and I can't express how much this has improved my quality of life."`,
    },
    {
      imageUrl: t6,
      name: "Emily R.",
      work: `"Improved My Skin Health Like Never Before"`,
      desc: `"I struggled with eczema for many years, and it was affecting my confidence and daily life. I tried several treatments, but nothing seemed to work. After starting homeopathy treatment with Homeopathy Healthcare and Research Center, I noticed visible improvement in my skin within weeks. I am now eczema-free, and I can't express how much this has improved my quality of life."`,
    },
    {
        imageUrl: t7,
        name: "Emily R.",
        work: `"Improved My Skin Health Like Never Before"`,
        desc: `"I struggled with eczema for many years, and it was affecting my confidence and daily life. I tried several treatments, but nothing seemed to work. After starting homeopathy treatment with Homeopathy Healthcare and Research Center, I noticed visible improvement in my skin within weeks. I am now eczema-free, and I can't express how much this has improved my quality of life."`,
      },
      {
        imageUrl: t8,
        name: "Emily R.",
        work: `"Improved My Skin Health Like Never Before"`,
        desc: `"I struggled with eczema for many years, and it was affecting my confidence and daily life. I tried several treatments, but nothing seemed to work. After starting homeopathy treatment with Homeopathy Healthcare and Research Center, I noticed visible improvement in my skin within weeks. I am now eczema-free, and I can't express how much this has improved my quality of life."`,
      },
      {
        imageUrl: t9,
        name: "Emily R.",
        work: `"Improved My Skin Health Like Never Before"`,
        desc: `"I struggled with eczema for many years, and it was affecting my confidence and daily life. I tried several treatments, but nothing seemed to work. After starting homeopathy treatment with Homeopathy Healthcare and Research Center, I noticed visible improvement in my skin within weeks. I am now eczema-free, and I can't express how much this has improved my quality of life."`,
      },
  ];
const { options, covertDriveLinkToImage } = useAuth();
 
  return (
    <div className="testimonial-container">
      <h1 className="our-treatments-h1" style={{ marginTop: "20px" }}>
        Teams
      </h1>
      <div
        style={{
          fontSize: "22px",
          color: "var(--primary-color)",
          textAlign: "center",
          margin: "20px 0px",
        }}
      >
        <b>Our Team: Healing with Homeopathy</b>
      </div>
      <p className="treat-para" style={{width:"90%",margin:"auto",textAlign: "center",marginTop:"30px",marginBottom:"30px" }}>
        At{" "}
        <b style={{ color: "var(--primary-color)" }}>
        Homeopathy Healthcare and Research Center
        </b>
        , our team is driven by a shared belief: that true healing comes from treating the individual as a whole — not just addressing symptoms, but uncovering and healing the root causes of illness.
        Our dedicated practitioners are proud to stand behind the inspiring journeys of our patients, whose stories showcase the gentle, transformative power of homeopathy. We invite you to meet the passionate individuals who make these success stories possible.
      </p>
      <div className="ta-sec-1">
        <img src={t1} />
      </div>
      <h2 style={{ textAlign: "center", color: "var(--primary-color)",margin:"50px 0px" }}>
       Our Team Members
      </h2>
      <div className="ta-sec-2">
        {options?.member.map((data)=>(<div className="ta-sec-2-content">
          <div className="test-image-1">
            <img src={covertDriveLinkToImage(data.image)}/>
          </div>
          <p style={{fontWeight:"600"}}>{data.name}</p>
          <h1 className="ta-h1">{data.role}</h1>
          <p>{data.description}</p>
        </div>))}
      </div>
      <div className="ta-last-sec">
        <h1 className="ta-last-h1">Join the Many Happy and Healed Patients at Homeopathy Healthcare and Research Center!</h1>
        <p style={{fontSize:"20px",marginBottom:"40px"}}>If you're ready to experience the transformative benefits of homeopathy and start your own healing journey, we invite you to contact us for a consultation. Whether you’re struggling with chronic conditions, looking for natural remedies, or simply seeking a holistic approach to your health, we’re here to guide you every step of the way.</p>
        <div><b style={{color:"var(--primary-color",textAlign:"center",fontSize:"20px"}}>Book your appointment today and take the first step toward a healthier, happier you!</b></div>
        <button className="treat-btn" onClick={handleAppointment}>BOOK APPOINTMENT</button>
      </div>
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment
            handleAppointment={handleAppointment}
          />
        </div>
      )}
    </div>
  );
};

export default Testimonials;
